import { Box, styled, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { vehicles } from "../../../constants/vehicleData";
import VehicleModelCards from "../../../SDK/Cards/VehicleModelCards";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { useMobile } from "../../../utils/findViewport";
const CustomVehicleLatestList = styled(Box)(({ theme }) => ({
  //   background: "#FFF9FA",
  background:
    "linear-gradient(180deg, #FFD6DD 0%, #FFF0CA 52.60%, #FFD6DD 93.75%)",
  padding: "40px",
  ".main-box": {
    margin: "10px",
    marginBottom: "20px",
  },
  ".head-text": {
    padding: "0px 10px",
    fontWeight: 600,
    fontSize: "27px",
    marginTop: "30px",
    paddingLeft: "16px",
  },
  ".sub-text": {
    fontSize: "12px",
    color: "#9C9A9D",
    fontWeight: "600",
    padding: "0px 10px",
    paddingLeft: "16px",
  },
  ".image-box": {
    width: "100%",
    padding: "20px 0px",
  },
  ".test-drive-image": {
    width: "100%",
  },
  ".book-test-drive-button": {
    borderRadius: "8px",
    boxShadow: "none",
    border: "none",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  ".MuiOutlinedInput-root": {
    paddingRight: "2px !important",
  },
  ".termsconditions": {
    fontSize: "10px",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "10px",
    // padding: "20px",
  },
  //   ".form-box": {
  //     width: "100%",
  //   },
}));

const VehicleLatestList = ({ headerInfo, latestVehiclesInfo, styleInfo, hideHeader = false }) => {
  const targetRef = useRef(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics("v2_scroll_latest_model", {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef]);

  const isMobile = useMobile();

  return (
    <CustomVehicleLatestList>
      <Box className="main-box" id="latest-model" ref={targetRef}>
        {!hideHeader && (
          <>
            <Box>
              <Typography className="head-text">
                {headerInfo ?? "Latest Model"}
              </Typography>
            </Box>
            <Box>
              <Typography className="sub-text">BY TURNO</Typography>
            </Box>
          </>
        )}

        <Box>
          <Swiper
            slidesPerView={isMobile ? 1.2 : 3.5}
            spaceBetween={isMobile ? 20 : 40}
            centeredSlides={false}
            pagination={false}
            loop={true}
            modules={[Pagination]}
            className="swiper-turno-india"
            onSlideChange={() => {
              let newCount = count + 1;
              setCount(newCount);
              if (newCount > 1)
                sendAnalytics("v2_latest_model_slide", {}, "en");
            }}
          >
            {vehicles?.map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <VehicleModelCards data={data} />

                  {/* <ModelCard data={data} /> */}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
      </Box>
    </CustomVehicleLatestList>
  );
};

export default VehicleLatestList;
